import type { Metadata, PaginationParams } from '@/types';
import type { MeetingAttendeeData } from '../../types';

import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type ResponseData = {
  data: MeetingAttendeeData[];
  metadata: Metadata;
};

type Params = {
  companyID: number;
  meetingID: number;
  queryParams?: {
    sort_by?: keyof MeetingAttendeeData;
    sort_dir?: 'asc' | 'desc';
    q?: string;
  } & PaginationParams;
};

export const getMeetingAttendees = async ({ companyID, meetingID, queryParams }: Params): Promise<ResponseData> => {
  const { data } = await axiosClient.get<ResponseData>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-attendance`,
    {
      params: queryParams,
    },
  );
  return data;
};
type QueryFnType = typeof getMeetingAttendees;

type UseGetMeetingAttendeesOptions = {
  companyID: number;
  meetingID: number;
  queryParams?: Params['queryParams'];
  config?: QueryFunction<QueryFnType>;
};

export const useGetMeetingAttendees = ({
  companyID,
  meetingID,
  queryParams,
  config,
}: UseGetMeetingAttendeesOptions) => {
  return useQuery({
    queryKey: ['meeting-attendees', companyID, meetingID, queryParams],
    queryFn: () => getMeetingAttendees({ companyID, meetingID, queryParams }),
    ...config,
  });
};
